/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2021] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

import { View } from 'backbone.marionette';
import Ladda from 'ladda';

import './SideNavLinkView.css';

import tmplSideNavLinkView from './SideNavLinkView.hbs';

const SideNavLinkView = View.extend({
  template: tmplSideNavLinkView,

  tagName: 'li',

  className: 'side-nav-link-view list-group-item cursor-pointer',

  attributes: {
    role: 'navigation',
    'aria-busy': true
  },

  ui: {
    link: 'a'
  },

  childViewEvents: {
    'has:errors': 'onModelHasErrors',
    'no:errors': 'onModelNoErrors'
  },

  modelEvents: {
    'has:errors': 'onModelHasErrors',
    'no:errors': 'onModelNoErrors'
  },

  events: {
    click: 'onClickLink'
  },

  onRender() {
    if (this.options.isLinkActive) {
      this.ui.link.addClass('active');
      this.$el.addClass('active');
    }
    this.initSpinner();
    this.bindModelViewEvents();
  },

  bindModelViewEvents() {
    this.model.get('view').on('has:errors', this.onModelHasErrors.bind(this));
    this.model.get('view').on('no:errors', this.onModelNoErrors.bind(this));
  },

  initSpinner() {
    this.spinner = Ladda.create(this.ui.link[0]);
  },

  onModelHasErrors() {
    this.ui.link.addClass('has-errors');
  },

  onModelNoErrors() {
    this.ui.link.removeClass('has-errors');
  },

  onClickLink(e) {
    e.preventDefault();
    this.triggerMethod('link:clicked', this.model);
  },

  isActive() {
    return this.$el.hasClass('active');
  },

  makeInactive() {
    this.$el.removeClass('active');
  },

  makeActive() {
    this.$el.addClass('active');
  },

  setLoading() {
    this.spinner.start();
  },

  setLoaded() {
    this.spinner.stop();
  }
});

export default SideNavLinkView;
